module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }